import { defineStore } from 'pinia'

/**
 * Multi-Windows store
 */
export const useMultiWindowStore = defineStore('multi-window', () => {
  // states

  /**
   * Child window map, it is constituted of : ID => window (object) | null
   * ID:
   * - subject_uri (for content & community(not filtered))
   * - subject_uri/filter (for community facet)
   * window:
   * - when we have the ref of the window we put it in the store in most of the case we don't have it (we can't pass ref of the window throw tabs)
   */
  const childWindows = reactive(new Map())

  // setter
  /**
   * @description Set a new child window into the store
   * @param winID
   * @param window
   */
  const setChildWindow = (winID: string, windowRef: Window | null) => {
    childWindows.set(winID, windowRef)
    return windowRef
  }
  /**
   * @description Remove a child window from the store
   * @param winID
   */
  const removeChildWindow = (winID: string) => {
    childWindows.delete(winID)
  }

  // getter
  /**
   * @description get a child window with their ID
   * @param winID
   */
  const getChildWindow = (winID: string) => {
    return childWindows.get(winID)
  }

  return {
    // states
    childWindows,
    // setter
    setChildWindow,
    removeChildWindow,
    // getter
    getChildWindow,
  }
})
